<template>
	<div
		:class="['panel', 'research_chart7',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">

			<div class="row">
				<div class="col-12 col-lg-12">
					<div
						v-if="isHeaderVisible"
						:class="[
							'panel_header',
							isBrand? 'sk' : '',
						]"
					>
						<h2>
							{{ block.block_title }}
						</h2>
						<div class="description mb-5" v-html="block.description" />
					</div>
				</div>
			</div>

			<div class="row">
				<div
					v-for="(item, index) in block.items"
					:key="index"
					:class="'align-self-end col-12 col-lg-6 research_chart7-' +(index+1)"
				>

					<div v-if="index===0" class="bb-1">
						<div class="title">
							{{ item.chart_title }}
						</div>
					</div>
					<div v-else class="bb-1">
						<!--<img src="/research/Group-2.svg" class="frame f7">-->
						<div class="row">
							<div class="col-12 col-lg-12">
								<div class="title">
									{{ item.chart_title }}
								</div>
							</div>
						</div>
					</div>
					<b-embed
						type="iframe"
						:aspect="$device.isDesktop?item.proportions:item.proportions_mobile"
						:src="item.chart"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'ResearchChart',
	props: {
		block: { type: Object, required: true },
		index: { type: Number, required: true },
	},
	mixins: [panel],
	data() {
		return {};
	},
};
</script>

<style lang="scss">
    .flourish-credit {
        display: none;
    }
</style>
<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/research-chart";
</style>
